var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.shipment)?_c('h1',[_vm._v(" "+_vm._s(_vm.$t("shipment"))+" "+_vm._s(_vm.shipment.reference || _vm.shipment.id)+" ")]):_vm._e(),_c('extra-shipment',{attrs:{"shipment":_vm.shipment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }